/**
 * POST `admin/payments/{id}/refund` — ручная пометка возврата (v1, без
 * провайдера): создаётся отдельная запись «Возврат» со ссылкой на платёж
 * (ADMIN_BACKEND §6.2). Причина обязательна, уезжает в аудит.
 */

import {apiEnabled, http} from '@services/utils';

import type {MarkRefundInput} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const markRefund = async (input: MarkRefundInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(700);
    return {ok: true};
  }

  await http(`admin/payments/${encodeURIComponent(input.paymentId)}/refund`, {
    method: 'POST',
    body: {reason: input.reason},
    skipCaseConversion: true,
  });
  return {ok: true};
};
